import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../auth/api";
import { alertSuccess, alertError } from "../components/Alert";

// Fetch Help Support Queries
export const fetchHelpSupportQuery = createAsyncThunk(
  "helpSupportQuery/fetchHelpSupportQuery",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/HelpSupport/panel/query");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Help Support Query
export const addHelpSupportQuery = createAsyncThunk(
  "helpSupportQuery/addHelpSupportQuery",
  async (newQueryData, { rejectWithValue }) => {
    try {
      const response = await api.post("/HelpSupport/panel/query", newQueryData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Help Support Query
export const updateHelpSupportQuery = createAsyncThunk(
  "helpSupportQuery/updateHelpSupportQuery",
  async (queryData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/HelpSupport/panel/query", queryData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Help Support Query Slice
const helpSupportQuerySlice = createSlice({
  name: "helpSupportQuery",
  initialState: {
    helpSupportQueryList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Help Support Queries
      .addCase(fetchHelpSupportQuery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchHelpSupportQuery.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.helpSupportQueryList = action.payload;
      })
      .addCase(fetchHelpSupportQuery.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Help Support Query
      .addCase(addHelpSupportQuery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addHelpSupportQuery.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addHelpSupportQuery.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Help Support Query
      .addCase(updateHelpSupportQuery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateHelpSupportQuery.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateHelpSupportQuery.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = helpSupportQuerySlice.actions;

export default helpSupportQuerySlice.reducer;
